import React from "react";
import Success from "../../../assets/img/Success.png";
import ErrorModal from "../../../assets/svg/ErrorModal.svg";
import Modal from "../../../components/Modal/Modal";

function RequestHandlingModals({
  isModalOpen,
  isMaxCharCount,
  isDone,
  isMentorRole,
  setIsModalOpen,
  isNotifyModalOpen,
  setIsNotifyModalOpen,
  isErrorModalOpen,
  isNotify,
  setIsErrorModalOpen,
  setIsNotify,
  setIsCommentSent,
  isCommentSent,
  isCommentTrue,
  setIsCommentTrue,
}) {
  return (
    <div>
      {isModalOpen && (
        <Modal
          image={Success}
          description={
            isMaxCharCount
              ? "Tvoja introspekcija nije spremljena zbog previše znakova (max. 4000)."
              : isDone
                ? "Tvoja introspekcija je uspješno spremljena."
                : "Tvoja introspekcija je uspješno spremljena, ali nema dovoljno znakova (min. 1300) da bi bila završena."
          }
          buttons={[
            {
              label: "U redu",
              action: () => {
                setIsModalOpen(false);
              },
              className: "modal-btn-success",
            },
          ]}
        />
      )}
      {isNotifyModalOpen && !isMentorRole && (
        <Modal
          image={Success}
          description={
            "Uspješno ste obavijestili mentora o završetku pisanja introspekcije"
          }
          buttons={[
            {
              label: "U redu",
              action: () => {
                setIsNotifyModalOpen(false);
              },
              className: "modal-btn-success",
            },
          ]}
        />
      )}
      {isErrorModalOpen && (
        <Modal
          image={ErrorModal}
          description={
            isNotify
              ? "Dogodila se greška u slanju notifikacije mentoru, osvježite stranicu i pokušajte ponovo"
              : "Tvoja introspekcija nije spremljena, pokušajte ponovo."
          }
          buttons={[
            {
              label: "U redu",
              action: () => {
                setIsErrorModalOpen(false);
                setIsNotify(false);
              },
              className: "modal-btn-success",
            },
          ]}
        />
      )}
      {isCommentSent && typeof isCommentTrue === "boolean" && (
        <Modal
          image={Success}
          description={
            isCommentTrue
              ? "Komentar je uspješno poslan te je polaznik obaviješten"
              : "Komentar je spremljen, a bit će poslan polazniku kada napišete cjeloviti komentar. (min. 150 znakova)"
          }
          buttons={[
            {
              label: "U redu",
              action: () => {
                setIsCommentSent(false);
                setIsCommentTrue(false);
              },
              className: "modal-btn-success",
            },
          ]}
        />
      )}
    </div>
  );
}

export default RequestHandlingModals;
